import styled from 'styled-components'

import { Badge, DataTable } from '@/components'
import { MainGolfSearchNoData } from '@/pages/main/_components/golfSearch/mainGolfSearchNoData'
import { tableStyles } from '@/pages/main/_components/golfSearch/style'
import { useGolfSearchData } from '@/pages/main/_components/golfSearch/useGolfSearchData'
import {
  GolfSearchState,
  setSearchParams,
} from '@/redux/slices/golfSearchSlice'
import numberUtils from '@/utils/numberUtils'
import { useEffect, useRef, useState } from 'react'
import { TableColumn } from 'react-data-table-component'
import {
  useLocation,
  useNavigate,
  Link,
  useSearchParams,
} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/redux/store'
import { useRedis } from '@/hooks/useRedis'
import { useResponsive } from '@/hooks/useResponsive'

interface DataRow {
  bizCd: string
  areaCd: string
  bizNm: string
  areaNm: string
  n01: string
  n02: string
  m01: string
  m02: string
  mshipYn?: string | null
  holeType: string
  confidenceLvlCd: string
}

interface MainGolfSearchResultProps {
  updateFilter?: (
    key: keyof GolfSearchState,
    value: string | number | null,
  ) => void
}
export const MainGolfSearchResult = () => {
  // const { data } = useGolfSearchData()
  const data = useSelector(
    (state: RootState) => state.golfSearch.golfListData.listData,
  )
  // Redux에서 searchParams 가져오기
  const searchParams = useSelector(
    (state: RootState) => state.golfSearch.searchParams,
  )
  const navigate = useNavigate()
  const [sortColumn, setSortColumn] = useState('bizNm')
  const [direction, setDirection] = useState('asc')

  const location = useLocation()
  const isMain = location.pathname == '/' || location.pathname == '/main'

  const { getComCodeValue } = useRedis()

  const [searchParamsRouter] = useSearchParams() // ⬅️ 쿼리스트링 추출
  const { isMobile, isTablet, isDesktop } = useResponsive()
  // const handleBizClick = (row: DataRow) => {
  //   navigate('/golf/detailInfo', {
  //     state: {
  //       bizCd: row.bizCd,
  //       golfAreaCd: row.areaCd, //modify by ljh 2025.07.21 지역버튼 영역 이전 값 유지를 위해 areaCd 제거
  //       // areaNm : row.areaNm,
  //       prevPage: 'main',
  //     },
  //   })
  // }

  const handleBizClick = (row: DataRow) => {
    localStorage.setItem('prevPage', 'main')
    localStorage.setItem('prevAreaCode', searchParams.areaCd || '')
    localStorage.setItem(
      'prevIsNationwide',
      String(searchParams.isNationwide || false),
    ) // 이 줄만 추가

    navigate('/golf/detailInfo', {
      state: {
        bizCd: row.bizCd,
        golfAreaCd: row.areaCd,
        prevPage: 'main',
        isNationwide: searchParams.isNationwide, // 이 줄 추가
      },
    })
  }

  const columns: TableColumn<DataRow>[] = [
    {
      name: (
        <>
          골프장
          {/* {sortColumn === 'bizNm' ? (direction === 'asc' ? ' ▲' : ' ▼') : ''} */}
        </>
      ),
      selector: (row) => row.bizNm,
      sortable: true,
      sortField: 'bizNm',
      sortFunction: (a, b) => a.bizNm.localeCompare(b.bizNm),
      cell: (row) => (
        <div
          onClick={() => handleBizClick(row)}
          style={{
            cursor: 'pointer',
            color: 'blue',
            fontWeight: sortColumn === 'bizNm' ? 'bold' : '',
          }}
        >
          {row.mshipYn === 'Y' ? (
            <Badge color="rgb(16, 183, 89)" shape="circle">
              회
            </Badge>
          ) : row.mshipYn === 'N' ? (
            <Badge color="rgb(33, 123, 201)" shape="circle">
              대
            </Badge>
          ) : null}
          &nbsp;{row.bizNm}
        </div>
      ),
    },
    {
      name: (
        <>
          지역
          {/* {sortColumn === 'areaNm' ? (direction === 'asc' ? ' ▲' : ' ▼') : ''} */}
        </>
      ),
      selector: (row) => row.areaNm,
      sortable: true,
      center: true,
      sortField: 'areaNm',
      cell: (row) => (
        <div
          style={{
            fontWeight: sortColumn == 'areaNm' ? 'bold' : '',
          }}
        >
          {row.areaNm}
        </div>
      ),
    },
    {
      name: (
        <>
          홀 타입
          {/* {sortColumn === 'areaNm' ? (direction === 'asc' ? ' ▲' : ' ▼') : ''} */}
        </>
      ),

      selector: (row) => row.holeType,
      sortable: true,
      center: true,
      sortField: 'holeType',
      cell: (row) => (
        <div
          style={{
            fontWeight: sortColumn == 'holeType' ? 'bold' : '',
          }}
        >
          {getComCodeValue('HOLE_TYPE', row.holeType)?.codeNm || row.holeType}
        </div>
      ),
    },
    {
      name: (
        <>
          비회원(주중)
          {/* {sortColumn === 'n01' ? (direction === 'asc' ? ' ▲' : ' ▼') : ''} */}
        </>
      ),
      selector: (row) => row.n01,
      sortable: true,
      sortField: 'n01',
      cell: (row) => (
        <div
          style={{
            width: '100%',
            textAlign: 'right',
            fontWeight: sortColumn == 'n01' ? 'bold' : '',
          }}
        >
          {typeof row.n01 === 'number' && row.n01 === 0
            ? '갱신중'
            : numberUtils.formatNumberWithCommas(row.n01) || '-'}
        </div>
      ),
    },
    {
      name: (
        <>
          비회원(주말)
          {/* {sortColumn === 'n02' ? (direction === 'asc' ? ' ▲' : ' ▼') : ''} */}
        </>
      ),
      selector: (row) => row.n02,
      sortable: true,
      sortField: 'n02',
      cell: (row) => (
        <div
          style={{
            width: '100%',
            textAlign: 'right',
            fontWeight: sortColumn == 'n02' ? 'bold' : '',
          }}
        >
          {typeof row.n02 === 'number' && row.n02 === 0
            ? '갱신중'
            : numberUtils.formatNumberWithCommas(row.n02) || '-'}
        </div>
      ),
    },
    {
      name: (
        <>
          회원(주중)
          {/* {sortColumn === 'm01' ? (direction === 'asc' ? ' ▲' : ' ▼') : ''} */}
        </>
      ),
      selector: (row) => row.m01,
      sortable: true,
      sortField: 'm01',
      cell: (row) => (
        <div
          style={{
            width: '100%',
            textAlign: 'right',
            fontWeight: sortColumn == 'm01' ? 'bold' : '',
          }}
        >
          {typeof row.m01 === 'number' && row.m01 === 0
            ? '갱신중'
            : numberUtils.formatNumberWithCommas(row.m01) || '-'}
        </div>
      ),
    },
    {
      name: (
        <>
          회원(주말)
          {/* {sortColumn === 'm02' ? (direction === 'asc' ? ' ▲' : ' ▼') : ''} */}
        </>
      ),
      selector: (row) => row.m02,
      sortable: true,
      sortField: 'm02',
      cell: (row) => (
        <div
          style={{
            width: '100%',
            textAlign: 'right',
            fontWeight: sortColumn == 'm02' ? 'bold' : '',
          }}
        >
          {typeof row.m02 === 'number' && row.m02 === 0
            ? '갱신중'
            : numberUtils.formatNumberWithCommas(row.m02) || '-'}
        </div>
      ),
    },
    {
      name: (
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '2px', // 텍스트와 아이콘 사이 간격
          }}
          title="그린피에 대한 정확도 정보입니다."
        >
          정확도
          <img
            src="/svg/question-mark-circle-outline-icon.svg"
            alt="도움말"
            width="12"
            height="12"
            style={{ verticalAlign: 'middle' }}
          />
        </span>
      ),
      selector: (row) => row.confidenceLvlCd,
      sortable: true,
      center: true,
      sortField: 'confidenceLvlCd',
      cell: (row) => (
        <div
          style={{
            fontWeight: sortColumn == 'confidenceLvlCd' ? 'bold' : '',
          }}
        >
          {getComCodeValue('CONFIDENCE_LVL_CD', row.confidenceLvlCd)?.codeNm ||
            row.confidenceLvlCd}
        </div>
      ),
    },
  ]

  return (
    <MainGolfSearchContainerWrapper>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          {isMain && !isMobile && (
            <span>
              * 상단 메뉴 &nbsp;
              <Link
                to="/golf/detailSearch"
                style={{ color: 'red', fontWeight: 'bold' }}
              >
                <strong>꿀프장검색</strong>
              </Link>
              에서 다양한 그래프와 정보를 확인하실 수 있습니다.
            </span>
          )}

          {isMain && isMobile && (
            <>
              <div
                style={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  width: '100%',
                }}
              >
                <Link
                  to="/golf/detailSearch"
                  style={{ color: 'red', fontWeight: 'bold' }}
                >
                  <strong>* 꿀프장검색</strong>
                </Link>
                에서 다양한 그래프와 정보를 확인하실 수 있습니다.
              </div>
              <BadgeWrapper>
                <div
                  style={{ display: 'flex', gap: '16px', alignItems: 'center' }}
                >
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <Badge color="rgb(16, 183, 89)" shape="circle">
                      회
                    </Badge>
                    <span>: 회원제</span>
                  </span>

                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <Badge color="rgb(33, 123, 201)" shape="circle">
                      대
                    </Badge>
                    <span>: 대중제</span>
                  </span>
                </div>
              </BadgeWrapper>
            </>
          )}
        </div>
        {isMain && !isMobile && (
          <BadgeWrapper>
            <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
              <span
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                <Badge color="rgb(16, 183, 89)" shape="circle">
                  회
                </Badge>
                <span>: 회원제</span>
              </span>

              <span
                style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              >
                <Badge color="rgb(33, 123, 201)" shape="circle">
                  대
                </Badge>
                <span>: 대중제</span>
              </span>
            </div>
          </BadgeWrapper>
        )}
      </div>
      <DataTable
        columns={columns}
        data={data}
        customStyles={tableStyles}
        noDataComponent={<MainGolfSearchNoData />}
        fixedHeader={true}
        defaultSortFieldId={'bizNm'}
        defaultSortAsc={false}
        onSort={(column: any, direct: string) => {
          // sortColumn.current = column.sortField
          // direction.current = direct;
          setSortColumn(column.sortField)
          setDirection(direct)
        }}
        // sortIcon={<></>}
      />
      <TotalCount>
        총 <b>{data.length}</b> 건
      </TotalCount>
    </MainGolfSearchContainerWrapper>
  )
}

const MainGolfSearchContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 400px;
  margin-top: 30px;
`

const BadgeWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 10px;
`
const TotalCount = styled.p`
  margin-left: auto;
  margin-right: 10px;
  margin-top: 10px;
`
